module.exports = __webpack_public_path__ + "static/img/2.385215a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/3/sp/2.png
// module id = nZfA
// module chunks = 0